<script>
import { appConfig } from '../../app.config'
import { services } from '../../utils/common-services'

export default {
  page: {
    title: 'Login',
    meta: [{ name: 'description', content: `Login to ${appConfig.title}` }],
  },

  data() {
    return {
      uid: null,

      showSuccess: false,
      validationMessage: null,
      showForgotPassword: false,
      loginPage: null,
      resetPassword: false,
      showLogin: true,

      verified: false,
      emailVerified: false,
      emailNotVerified: false,
      passwordVerified: false,
      title: 'Set your password',
      token: null,
    }
  },
  beforeDestroy() {
    var doc = this.$refs.forgotpasswordverification
    if (doc !== undefined) doc.innerHTML = ''
  },
  beforeMount() {
    services.logOut()
    this.uid = this.$route.params.uid
    this.token = this.$route.params.token
    this.passwordVerified = true
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    login(data) {
      if (data) {
        this.passwordVerified = false
        this.loginPage = true
        let parent = this
        setTimeout(() => {
          // parent.loginPage=false
          parent.$router.push({ name: 'login' })
        }, 3000)
      }
    },
  },
}
</script>

<template>
  <div ref="forgotpasswordverification">
    <div v-if="passwordVerified">
      <CommonBasePasswordReset
        :token="token"
        :uid="uid"
        title="Reset your password"
        :reset="true"
        @login="login"
      />
    </div>
    <div v-if="loginPage"> <CommonBaseVerificationSession :verify="true"/></div>
    <div v-if="emailNotVerified">
      <CommonBaseVerificationSession
        :verified="false"
        :session="true"
        message="Your password reset Llink has been expired"
    /></div>

    <div :class="$style.toasterMainWrap">
      <!-- <b-button @click="$bvToast.show('rightToWorkToaster')">Show toast</b-button> -->
      <b-toast id="reset" solid>
        <div
          class="d-flex"
          :class="
            showSuccess
              ? [$style.loginToasterWraper, $style.success]
              : [$style.loginToasterWraper, $style.error]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ validationMessage }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
</style>
